import React from 'react';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { PieChart } from '../../../../../CommonComponents/OPL/charts/PieChart/PieChart';
import { theme } from '../../../../../theme/theme';

const defaultSeriesData = [
  { name: 'One', y: 85, color: theme.colors.neutral['400'] },
  { name: 'Two', y: 15, color: theme.colors.neutral['200'] },
];

export const Chart = () => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" my="40">
      <Box width={134} height={134}>
        <PieChart
          series={[
            {
              data: defaultSeriesData,
            },
          ]}
          customSettings={{
            plotOptions: {
              pie: { innerSize: '60%' },
              series: {
                animation: false,
              },
            },
          }}
        />
      </Box>
    </Box>
  );
};
